import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import axios from "axios";
import "./earlybird.scss";

import {
  MenuItem,
  InputLabel,
  FormControl,
  Select,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Form from "../Home/Form";
import Countdown from "../../Reusables/Countdown";
import Testimonials from "../Home/Testimonials";
import { Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
// const stripePromise = loadStripe("pk_test_HGDc5rMpzlE4NJvFygwF1zIW");
const stripePromise = await loadStripe("pk_live_aRr3qYrpVTbyNgBbB7t0jqiy");

export default function EarlyBird() {
  const navigate = useNavigate();
  // const url = "http://localhost:4100";
  const url = "https://dev.pmwevents.com";
  const startDate = "2026/01/01 17:00:00";
  const today = moment();
  const [payment, setPayment] = useState(false);
  const [tncs, setTncs] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [attendees, setAttendees] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [showCount, setShowCount] = useState(true);
  const [options, setOptions] = useState({});
  const [showPayment, setShowPayment] = useState(false);
  const [formData, setFormData] = useState([]);
  const [errors, setErrors] = useState([]);

  // alerts
  const [message, setMessage] = useState("");
  const [alert, setAlert] = useState(false);
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    if (today.diff(moment(startDate), "seconds") > 0) {
      setShowCount(false);
    }
  }, [showCount, today]);

  const handleAlert = (message, duration = 3000) => {
    setDisable(true);
    setMessage(message);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setDisable(false);
    }, duration);
  };

  const handleQuantity = async (quantity) => {
    setQuantity(parseInt(quantity));
    let total = parseInt(77) * 1.2 * parseInt(quantity);
    setTotalPrice(total.toFixed(2));
  };

  const handleInputChange = (e, idx, field) => {
    const updatedData = [...formData];
    updatedData[idx] = {
      ...updatedData[idx],
      [field]: e.target.value,
      ticketId: 7,
      paidAmount: 92.40,
      ticketType: "General",
    };
    setFormData(updatedData);
  };

  const validateField = (field, value) => {
    switch (field) {
      case "email":
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
          ? ""
          : "Please enter a valid email address.";
      case "phone":
        return /^(?:\+44|0)7\d{9}$|^(?:\+44|0)1\d{10}$|^(?:\+44|0)2\d{10}$/.test(
          value
        )
          ? ""
          : "Please enter a valid phone number (e.g., +44 7123 456789).";
      case "postcode":
        return /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/i.test(value)
          ? ""
          : "Please enter a valid postcode (e.g., SW1A 1AA).";
      default:
        return value ? "" : `Please enter your ${field}.`;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = [];
    setErrors([]);

    formData.forEach((attendee, idx) => {
      const attendeeErrors = {};

      ["name", "lastName", "email", "phone", "address", "postcode"].forEach(
        (field) => {
          const error = validateField(field, attendee[field]);
          if (error) {
            attendeeErrors[field] = error;
          }
        }
      );

      if (Object.keys(attendeeErrors).length > 0) {
        newErrors[idx] = attendeeErrors;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else if (!tncs) {
      handleAlert("Please check terms & conditions");
    } else {
      setErrors([]);
      handleSecret();
    }
  };

  const handleSecret = async () => {
    let formattedAttendees = formData.flat();

    formattedAttendees = formattedAttendees.map((a, i) => {
      let attendeeId = `122-7-${moment().format("DD-MM-YYYY")}-${Math.floor(
        1000 + Math.random() * 9000
      )}`;

      return {
        ...a,
        eventId: 122,
        attendeeId: attendeeId,
      };
    });

    console.log({
      quantity: quantity,
      attendees: formattedAttendees,
    });

    await axios
      .post(`${url}/sbc/early-bird-secret`, {
        quantity: quantity,
        attendees: formattedAttendees,
      })
      .then((res) => {
        setOptions({ clientSecret: res.data.clientSecret });
        setPayment(true);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.message) {
          handleAlert(err.response.data.message);
        } else {
          handleAlert("Something went wrong - Contact support");
        }
      });
  };

  const scrollTo = () => {
    document.getElementById("tickets").scrollIntoView();
  };

  return (
    <main className="eb__main">
      {/* {showCount ? <Countdown /> : null} */}
      {/* <iframe
        height="800"
        style={{ marginTop: "4%", width: "90%" }}
        src="https://player.vimeo.com/video/1053087190?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
        title="SBC EARLY BIRD LOOP 1080"
      ></iframe> */}
      {!payment ? (
        <>
          <h3>Early Bird ticket gives you access to:</h3>
          <h4>
            <span>Lowest prices EVER:</span> Including the biggest discounts on
            all upgrades!
          </h4>
          <h4>
            <span>Guaranteed access:</span> SBC25 was packed, SBC26 will sell
            out!
          </h4>
          {showCount ? (
            <>
              <h6>Limited Early Bird Spots! Secure Yours Now!</h6>
              <button className="cart--btn" onClick={scrollTo}>
                Claim My Early Bird Tickets Now
              </button>
            </>
          ) : (
            <>
              <h6>
                Early bird tickets are sold out, join the waiting list to be
                notified when tickets go on sale
              </h6>
              <button className="cart--btn" onClick={scrollTo}>
                Join the waiting list
              </button>
            </>
          )}
          {/* <h1>VIDEO GOES HERE</h1> */}
          {/* <Testimonials /> */}
          <section className="att__details">
            {showCount ? (
              <>
                <h6>Secure My Early Bird Tickets Now</h6>
                <FormControl
                  className="select--width"
                  id="tickets"
                  variant="filled"
                >
                  <InputLabel id="demo-simple-select-label">
                    How many seats?
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={quantity}
                    label="Quantity"
                    onChange={(e) => handleQuantity(parseInt(e.target.value))}
                  >
                    <MenuItem value={1}>One</MenuItem>
                    <MenuItem value={2}>Two</MenuItem>
                    <MenuItem value={3}>Three</MenuItem>
                    <MenuItem value={4}>Four</MenuItem>
                  </Select>
                </FormControl>
                {quantity > 0 ? (
                  <section className="attendee-forms">
                    <section className="attendee-forms">
                      <h4>Please fill in details for all attendees</h4>
                      <form onSubmit={handleSubmit}>
                        <div className="form-type-section">
                          {new Array(quantity).fill(null).map((_, idx) => (
                            <div key={idx} className="contact-form">
                              <div>
                                <label htmlFor={`name-${idx}`}>
                                  First Name:
                                </label>
                                <input
                                  type="text"
                                  id={`name-${idx}`}
                                  name="name"
                                  placeholder="Fist Name"
                                  required
                                  onChange={(e) =>
                                    handleInputChange(e, idx, "name")
                                  }
                                />
                                {errors[idx] && errors[idx].firstName && (
                                  <div className="error">
                                    {errors[idx].firstName}
                                  </div>
                                )}
                              </div>

                              <div>
                                <label htmlFor={`lastName-${idx}`}>
                                  Last Name:
                                </label>
                                <input
                                  type="text"
                                  id={`lastName-${idx}`}
                                  name="lastName"
                                  placeholder="Last Name"
                                  required
                                  onChange={(e) =>
                                    handleInputChange(e, idx, "lastName")
                                  }
                                />
                                {errors[idx] && errors[idx].lastName && (
                                  <div className="error">
                                    {errors[idx].lastName}
                                  </div>
                                )}
                              </div>

                              <div>
                                <label htmlFor={`email-${idx}`}>Email:</label>
                                <input
                                  type="email"
                                  id={`email-${idx}`}
                                  name="email"
                                  placeholder="Email"
                                  required
                                  onChange={(e) =>
                                    handleInputChange(e, idx, "email")
                                  }
                                />
                                {errors[idx] && errors[idx].email && (
                                  <div className="error">
                                    {errors[idx].email}
                                  </div>
                                )}
                              </div>

                              <div>
                                <label htmlFor={`phone-${idx}`}>
                                  Phone Number:
                                </label>
                                <input
                                  type="text"
                                  id={`phone-${idx}`}
                                  name="phone"
                                  placeholder="Phone Number"
                                  required
                                  onChange={(e) =>
                                    handleInputChange(e, idx, "phone")
                                  }
                                />
                                {errors[idx] && errors[idx].phone && (
                                  <div className="error">
                                    {errors[idx].phone}
                                  </div>
                                )}
                              </div>

                              <div>
                                <label htmlFor={`address-${idx}`}>
                                  Address:
                                </label>
                                <input
                                  type="text"
                                  id={`address-${idx}`}
                                  name="address"
                                  placeholder="Address"
                                  required
                                  onChange={(e) =>
                                    handleInputChange(e, idx, "address")
                                  }
                                />
                                {errors &&
                                  errors[idx] &&
                                  errors[idx].address && (
                                    <div className="error">
                                      {errors[idx].address}
                                    </div>
                                  )}
                              </div>

                              <div>
                                <label htmlFor={`postcode-${idx}`}>
                                  Postcode:
                                </label>
                                <input
                                  type="text"
                                  id={`postcode-${idx}`}
                                  name="postcode"
                                  placeholder="Postcode"
                                  required
                                  onChange={(e) =>
                                    handleInputChange(e, idx, "postcode")
                                  }
                                />
                                {errors[idx] && errors[idx].postcode && (
                                  <div className="error">
                                    {errors[idx].postcode}
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>

                        {totalPrice === 0 ? null : (
                          <strong>
                            Total: £{parseInt(totalPrice / 1.2)} + VAT
                          </strong>
                        )}
                        <div className="payment-terms">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="I confirm I have read and agree to the terms & conditions"
                            onChange={() => setTncs(!tncs)}
                          />
                          {alert ? <p>{message}</p> : null}
                          <Button
                            type="submit"
                            variant="outlined"
                            endIcon={<ArrowForwardIcon />}
                            className="to-payment-btn"
                            disabled={disable}
                          >
                            Continue to Payment
                          </Button>
                        </div>
                      </form>
                    </section>
                  </section>
                ) : null}
              </>
            ) : (
              <Form />
            )}
          </section>
        </>
      ) : (
        <div className="payment-portal">
          <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        </div>
      )}
    </main>
  );
}
